import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";

export default function UpdateUserAddress(props) {
  const {
    closeModal,
    update,
    isMobile,
    address,
    placeOrder,
    handleUpdateUserAddresses,
    selectedSavedAddressIndex,
  } = props;

  async function confirmUpdate(index) {
    await handleUpdateUserAddresses(update, address, index);
  }
  let updateText = null;
  if (update === 0) {
    updateText = "Delete";
  } else if (update === 1) {
    updateText = "Add";
  } else if (update === 2) {
    updateText = "Update";
  } else {
    updateText = "Set as Default";
  }

  return (
    <Modal
      onHide={() => closeModal(null)}
      show={true}
      className="confirm-order-modal"
    >
      <Alert variant="success" className={isMobile ? "w-100" : "w-50"}>
        <Alert.Heading>{`${updateText} User Address`}</Alert.Heading>
        <hr />
        <p>{`${updateText} address ${address.addressLine1}`}</p>
        <div className="d-flex justify-content-end">
          <div
            className="d-flex justify-content-between mt-2"
            style={{ width: isMobile ? "68%" : "30%" }}
          >
            <Button
              className="w-50 mr-2"
              onClick={() =>
                confirmUpdate(
                  update === 2 ? selectedSavedAddressIndex : null
                ).then(() => {
                  closeModal();
                  if (update === 1 || update === 2) {
                    placeOrder(address);
                  }
                })
              }
              variant="outline-success"
            >
              Confirm
            </Button>
            <Button
              className="w-50"
              onClick={() => {
                if (update === 1) {
                  placeOrder(address);
                }
                closeModal();
              }}
              variant="outline-success"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Alert>
    </Modal>
  );
}
